import { faEnvelope, faKey } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Message } from "shared/components/Message";
import { accountMessages } from "domain/account/accountMessages";
import React, { FC } from "react";
import { Link } from "react-router-dom";
import { Button } from "reactstrap";
import { routes } from "routes/routes";

interface IProps {
    className?: string;
    size?: string;
}

export const AccountNavigation: FC<IProps> = ({
    className,
    size,
}) => (
    <>
        <Button className={className} size={size} tag={Link} to={routes.account.edit.create({})}>
            <Message message={accountMessages.changeAccountDetailsLabel} />
        </Button>
        <Button className={className} size={size} tag={Link} to={routes.account.email.create({})}>
            <Message
                message={accountMessages.changeEmailAddressLabel}
                values={{
                    icon: <FontAwesomeIcon aria-hidden="true" icon={faEnvelope} />,
                }} />
        </Button>
        <Button className={className} size={size} tag={Link} to={routes.user.changePassword.create({})}>
            <Message
                message={accountMessages.changePasswordLabel}
                values={{
                    icon: <FontAwesomeIcon aria-hidden="true" icon={faKey} />,
                }} />
        </Button>
    </>
);
